import { DisplayIntegration } from '../types';

import ComponentHeader from './components/ComponentHeader';

export const GoErpDisplay: DisplayIntegration = {
  ComponentHeader,
};
